import { useState } from "react";
import useSearchParams from "../../../hooks/useSearchParams";

const useVariationCard = () => {
  const [hover, setHover] = useState(false);
  const { setParam } = useSearchParams();

  const handleClick = (data) => {
    setParam("var", data);
  };

  return { handleClick, hover, setHover };
};

export default useVariationCard;
